<template>
  <div>
    <!-- <h3 class="mt-2">Admin Users</h3> -->
    <!-- <div class="float-left "> -->
      <!-- <h4 class="font-weight-bold mt-2">Admin Users</h4>
      <div class="row m-0 p-0">
        <a href="/" style="margin-top: -3px;">
          <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.10302 0.473538C6.91735 0.298002 6.67153 0.200195 6.41602 0.200195C6.16051 0.200195 5.91469 0.298002 5.72902 0.473538L0.885016 5.05154C0.736698 5.19189 0.618598 5.36105 0.537952 5.54865C0.457307 5.73625 0.415814 5.93834 0.416016 6.14254V11.7125C0.416281 12.1102 0.574434 12.4915 0.85571 12.7726C1.13699 13.0536 1.51836 13.2115 1.91602 13.2115H3.41602C3.81384 13.2115 4.19537 13.0535 4.47668 12.7722C4.75798 12.4909 4.91602 12.1094 4.91602 11.7115V9.21154C4.91602 9.07893 4.9687 8.95175 5.06246 8.85798C5.15623 8.76422 5.28341 8.71154 5.41602 8.71154H7.41602C7.54862 8.71154 7.6758 8.76422 7.76957 8.85798C7.86334 8.95175 7.91602 9.07893 7.91602 9.21154V11.7115C7.91602 12.1094 8.07405 12.4909 8.35536 12.7722C8.63666 13.0535 9.01819 13.2115 9.41602 13.2115H10.916C11.3138 13.2115 11.6954 13.0535 11.9767 12.7722C12.258 12.4909 12.416 12.1094 12.416 11.7115V6.14154C12.416 5.93743 12.3742 5.73549 12.2934 5.54807C12.2126 5.36065 12.0944 5.19169 11.946 5.05154L7.10302 0.471538V0.473538Z"
              fill="#48a6a6" />
          </svg>
        </a>
        <span style="margin: -3px 12px 0 12px;">
          <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.227539 1.79558L1.27235 0.750765L6.22754 5.70595L1.27235 10.6611L0.227539 9.61632L4.13791 5.70595L0.227539 1.79558Z" fill="#9A9AB0" />
          </svg>
        </span>
        <breadcrumbs />
      </div> -->
    <!-- </div> -->
    <!-- <breadcrumbs/> -->
    <!-- <br /> -->
    <!-- <div class="float-right">
      <button type="button" class="btn-basic float-right" @click="createUser">
        Add New
      </button>
    </div>
    <div class="float-right">
      <download-excel class="btn btn-sm btn-outline-light color-default mr-3" style="
          color: #48a6a6 !important;
          border: 1px solid #48a6a6;
          padding: 8px 13px;
          margin-right: 6px;
          cursor: pointer;
        " :name="excelFileName" :data="adminUsers" :fields="json_fields">Excel Download
      </download-excel>
    </div> -->
    <!-- <br /><br /><br /> -->
    <div class="card card-body p-0 mt-2" style="border-radius: 10px">
      <div class="container row admin-users-filters" style="margin: 0 0; padding:0px !important;">
        
         <div class="col-9">
          <div class="row">
            <div class="col-3" v-if="$can('admin_users_filter_type')">
          <label class="type-label">Type</label >
          <multiselect  @input="changeType($event)" placeholder='All'  :options="type_filter"
          :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" v-model="selectedType"
          label="name" track-by="id" style="font-size:12px !important">
          </multiselect>
        </div>

         <div class="col-3" v-if="$can('admin_users_filter_team')">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Team</label>
                <multiselect @input="changeTeams($event)" :options="teams" :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" v-model="department"
                  label="name" track-by="id" style="font-size:12px !important" placeholder="Team">
                </multiselect>
              </div>
              <div v-else class="col-2">
              </div>
        <div class="col-3" v-if="[userRoles.development_lead].includes(loginUserRole)"></div>
        <div class="col-3" v-if="[userRoles.developer].includes(loginUserRole)"> </div>
          </div>
        </div>

        <!-- <div class="col-2">
          <select v-on:change="changeType($event)" style="background-color: #edf2f5" class="demo-date form-control" v-model="selectedType">
            <option value="">All</option>
            <option value="1">Admin</option>
            <option value="2">CRM</option>
            <option value="3">Editor</option>
            <option value="4">Support</option>
            <option value="5">Data Entry</option>
          </select>
        </div> -->
        <!-- <div class="col-5"></div> -->
        <div class="col-3" style='align-self: end;'>
        <div style="display:flex;flex-direction:row;width:100%;">
          <div class="type-label has-search" style="width:100% !important" v-if="$can('admin_users_search')">
            <label class="type-label">Search</label>            
            <span class="fa fa-search form-control-feedback"></span>
            <input type="text" style="background-color: #edf2f5" class="form-control" v-model="search" @keyup="usersBySearch" placeholder="Search User..." />
          </div>
        
          <!-- <div class="form-group mb-4" style="float: right; margin-left: 120px"> -->
            <download-excel id="excel" class="btn btn-sm btn-outline-light color-default excel-download" style="
                border: 1px solid #48a6a6;
                padding: 7px 9px 0px;
                margin-right: 6px;
                cursor: pointer;
                margin-top: 31.5px;
                margin-left: 12px;
                margin-bottom: 4px;
              " :name="excelFileName" :data="adminUsers" :fields="json_fields"  v-if="$can('admin_users_csv')">
                <i class="fa fa-file-excel-o" style="font-size:20px"></i>
            </download-excel> 
            <button  v-if="$can('admin_users_create')" @click="createUser" type="button" class="btn btn-sm float-right ml-2 add-more" style="
              color: white;
              border: 1px solid #48a6a6;
              padding: 6px 9px 0px;
              margin-right: 6px;
              cursor: pointer;
              margin-top: 31.5px;
              margin-left: 12px;
              margin-bottom: 4px;
            ">
              <span class="fa fa-plus" style="font-size:20px;color:#48a6a6;"></span>
            </button> 
          <!-- <div class="float-right">
            <button type="button" class="btn-basic float-right" @click="createUser">
              Add New
            </button>
          </div>
          <div class="float-right">
            <download-excel class="btn btn-sm btn-outline-light color-default mr-3" style="
                color: #48a6a6 !important;
                border: 1px solid #48a6a6;
                padding: 8px 13px;
                margin-right: 6px;
                cursor: pointer;
              " :name="excelFileName" :data="adminUsers" :fields="json_fields">Excel Download
            </download-excel>
          </div> -->
        </div>
        </div>
      </div>
      <!-- table -->
      <table class="table cheat border mx-0 px-0">
        <thead>
          <tr style="color: #48a6a6; background-color: #f4f8fa" class="text-left">
            <th>First Name</th>
            <th>Last Name</th>
            <th>Username</th>
            <th>Email</th>
            <th>Role</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody ref="formContainer">
          <tr  v-if="isLoader" id="table_row" >
            <td colspan="16">
              <b-skeleton-wrapper >
                  <b-skeleton height="40px" ></b-skeleton>   
                  <b-skeleton height="40px"></b-skeleton>  
                  <b-skeleton height="40px"></b-skeleton>                                     
              </b-skeleton-wrapper> 
            </td>
          </tr>
          <tr v-show="!isLoader" v-for="(user, index) in adminUsers" :key="index" class="text-left">
            <td v-if="user.role_id != '0'">{{ user.first_name }}</td>
            <td v-if="user.role_id != '0'">{{ user.last_name }}</td>
            <td v-if="user.role_id != '0'">{{ user.user_name }}</td>
            <td v-if="user.role_id != '0'">{{ user.email }}</td>
            <td v-if="user.role_id != '0'">
              <span id="role" v-if="user.role_id == '1'" class="font-weight-bold" style="color: #66b34d">
                <span class="bullet">• </span>Admin</span>
              <span id="role" v-if="user.role_id == '2'" class="font-weight-bold" style="color: #e95a42">
                <span class="bullet">• </span>CRM</span>
              <span id="role" v-if="user.role_id == '3'" class="font-weight-bold" style="color: #f19a16">
                <span class="bullet">• </span>Editor</span>
              <span id="role" v-if="user.role_id == '4'" class="font-weight-bold" style="color: #a682b2">
                <span class="bullet">• </span>Support</span>
              <span id="role" v-if="user.role_id == '5'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>Data Entry</span>
              <span id="role" v-if="user.role_id == '6'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>Digital Marketing</span>
              <span id="role" v-if="user.role_id == '7'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>ADH</span>
              <span id="role" v-if="user.role_id == '8'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>Development Lead</span>
              <span id="role" v-if="user.role_id == '9'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>Developer</span>
              <span id="role" v-if="user.role_id == '10'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>CSM</span>
                <span id="role" v-if="user.role_id == '11'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>ADH Helper</span>
                 <span id="role" v-if="user.role_id == '12'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>QA</span>
                 <span id="role" v-if="user.role_id == '13'" class="font-weight-bold" style="color: Violet">
                <span class="bullet">• </span>Designer</span>
            </td>

            <td v-if="user.role_id != '0'">
              <span class="badge badge-pill" :class="(user.status == 1 || user.status === true) ? 'badge-success' : 'badge-secondary'" style="font-size: 12px;">
                {{ (user.status == 1 || user.status === true) ? 'Active' : 'Inactive' }}
              </span>
            </td>

            <td v-if="user.role_id != '0'" class="text-center">
              <div class="btn-group" v-if="user.role_id != '1' || role == '0'">
                <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                  <span class="fas fa-ellipsis-v"></span>
                </a>
                <ul class="dropdown-menu" style="
                    max-width: 0rem !important;
                    color: #dbdbdb !important;
                    border: 1px solid #b6c7d2;
                    border-radius: 8px;
                    font-size: 12px;
                  ">
                  <a class="dropdown-item" v-if="user.role_id != '1' || role == '0'" @click="passwordReset" :data-id="user.id">Reset
                    Password</a>
                  <a class="dropdown-item" v-if="(user.role_id != '1' || role == '0') && role != '7'" @click="updateUser(user)" :data-id="user.id"
                    :data-fname="user.first_name" :data-lname="user.last_name" :data-uname="user.user_name"
                    :data-email="user.email" :data-usr_type="user.role_id" :data-client_id="user.zoom_credential != null ? user.zoom_credential.client_id:''" :data-client_secret="user.zoom_credential != null ?user.zoom_credential.client_secret: ''" :data-account_id="user.zoom_credential != null ? user.zoom_credential.account_id:''"
                    :data-team="user.user_team" >Update User</a>

                 <div v-else-if="role == '7'">
                  <a class="dropdown-item" v-if="user.role_id == '8' || user.role_id == '9' || user.id == user_id" @click="updateUser(user)" :data-id="user.id"
                    :data-fname="user.first_name" :data-lname="user.last_name" :data-uname="user.user_name"
                    :data-email="user.email" :data-usr_type="user.role_id" :data-client_id="user.zoom_credential != null ? user.zoom_credential.client_id:''" :data-client_secret="user.zoom_credential != null ?user.zoom_credential.client_secret: ''" :data-account_id="user.zoom_credential != null ? user.zoom_credential.account_id:''"
                    :data-team="user.user_team" >Update User</a>
                    </div>
                    
                    <!-- :data-task_type="user.task_type">Update User</a> -->
                  <a v-if="user.role_id != '1' || role == '0' " class="dropdown-item" @click="deleteUser" :data-id="user.id">Delete</a>
                   <a class="dropdown-item" v-if="$can('admin_users_onleave')" @click="onLeave(user)">On Leave</a>
                  <a class="dropdown-item" v-if="$can('admin_users_active')" @click="toggleActivation(user)">
                  {{ user.status ? 'Inactive' : 'Active' }}
            </a>
                   
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <h5 v-if="Object.keys(this.adminUsers).length < 1 && !isLoader" style="text-align: center">
        No data found.
      </h5>
       <div v-if="!isLoader" class="container-fluid" style="font-size: 14px; bottom: 0">
          <div class="row mt-1 justify-content-end d-flex float-right px-3">
            <span class="pr-3 pt-1">Display Rows: <b>{{ totalRows }}</b></span>  
            <paginate v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''" :first-button-text="''" :last-button-text="''" :first-last-button="true" :container-class="'pagination pagination-sm ml-auto mr-4'" :page-class="'page-item'" :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'" :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
          </div>
       </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import helpers from "@/helpers.js";
  import deleteForm from "./user_delete_form";
  import updateForm from "./user_update_form";
  import AdminUserForm from "./create_user_form";
  import ResetPasswordForm from "./reset_password_form";
  import VueSkeletonLoader from 'skeleton-loader-vue';
  import Multiselect from "vue-multiselect";
  import leaveForm from "./user_leave_form";
  import { mapGetters } from 'vuex';
  export default {
    components: {
      Multiselect,VueSkeletonLoader
    },
    data: function () {
      return {
        search: "",
        selectedType: "",
        page: 0,
        filter_team_id: "",
        fullPage: "",
        org_search_value: "all",
        organizations: [],
        awaitingSearch: false,
        excelDownloadData: [],
        excelFileName:"admin_users.xls",
        loginUserRole: JSON.parse(localStorage.getItem("role")),
        user_id:localStorage.getItem('admin_id'),
        json_fields: {
          "First Name": "first_name",
          "Last Name": "last_name",
          "User name": "user_name",
          Email: "email",
          Role: {
            field: "role_id",
            callback: (value) => {
              if (value == 1) {
                return `Admin`;
              } else if (value == 2) {
                return `CRM`;
              } else if (value == 3) {
                return `Editor`;
              } else if (value == 4) {
                return `Support`;
              }  else if (value == 5) {
                return `Data Entry`;
              } else if (value == 6) {
                return `Digital Marketing`;
              } else if (value == 7) {
                return `ADH`;
              } else if (value == 8) {
                return `Development Lead`;
              } else if (value == 9) {
                return `Developer`;
              }else if (value == 10) {
                return `CSM`;
              }else if (value == 11) {
                return `ADH Helper`;
              }else if (value == 12) {
                return `QA`;
              }else if (value == 13) {
                return `Designer`;
              }
            },
          },
          Status: {
            field: "status",
            callback: (value) => (value == 1 || value === true) ? "Active" : "Inactive",
          },
        },
        role: "",
        isLoader: true,
        type_filter: [
          {name:"All", id:""},
          {name:"Admin", id:1},
          {name:"CRM", id:2},
          {name:"Editor", id:3},
          {name:"Support", id:4},
          {name:"Data Entry", id:5},
          {name:"Digital Marketing", id:6},
          {name:"ADH", id:7},
          {name:"Development Lead", id:8},
          {name:"Developer", id:9},
          {name:"CSM", id:10},
          {name:"ADH Helper", id:11},
          {name:"QA", id:12},
          {name:"Designer", id:13},
        ],
      };
    },

    computed: {
      ...mapGetters('persist', ['teams']),
      currentPage: {
        get: function () {
          return this.page;
        },
        set: function () { },
      },
      adminUsers: function () {
        return this.$store.getters["users/adminUsers"];
      },
      products :function () {
        return this.$store.getters["users/products"];  
      },
      totalPages: function () {
        return this.$store.getters["users/totalPages"];
      },
      totalRows: function () {
         return this.$store.getters["users/totalRows"];
      },
      userRoles: function () {
				return this.$store.getters['persist/userRoles'];
			},
    },
    created: function () {
      console.log("tasktype", this.teams);
      this.role = localStorage.getItem("role");
      this.page = helpers.getPageQuery();
    },
    watch: {
      page: function () {
        this.isLoader = true;
        this.$store.dispatch("users/getAdminUsers",[]).
        then(() => {
          this.isLoader = false;
        });
      },
    },

    methods: {
      setPage(page) {
        this.page = page;
        this.$router.push("admin-users?page=" + page);
      },
      createUser() {

        this.selectedType='';
        this.search = '';
        this.$store.dispatch("modal/createUser", {
          action: "create",
          title: "Add User",
          show:true,
          component: AdminUserForm });
      },
      deleteUser(event) {
        let user = event.target.dataset.id;
        let pageNumber = this.page;

        this.$store.dispatch("modal/deleteUser", {
          action: "create",
          title: "Delete User",
          formData: {
            user: user,
            pageNumber: pageNumber,
            selectedType: this.selectedType,
          },
          component: deleteForm,
        });
      },
     onLeave(user) {
    this.$store.dispatch("modal/leaveUser", {
        action: "leave",
        title: "Leave User",
        formData:user,
        component: leaveForm,  
    });
},
  toggleActivation(user) {
    let confirmationMessage = !user.status ?
        "Do you want to active this user?" :
        "Do you want to inactive this user?";

    let confirmationResult = confirm(confirmationMessage);

    if (confirmationResult) {
        this.updateUserStatus(user);
    }
},


    updateUserStatus(user) {
       const permission = {
      headers: {
        'X-Permission': 'admin_users_active'
      }
    };
      user.status = !user.status;
      axios.post(`/admin/users/${user.id}`, { status: user.status ? 1 : 0 },permission)
        .then(response => {
          this.$toast.success("Status updated successfully");
        })
        .catch(error => {
          this.$toast.error("Error occurred ");
          user.status = !user.status;
        });
    },
      
      passwordReset(event) {
        let user = event.target.dataset.id;
        let pageNumber = this.page;
        this.$store.dispatch("modal/passwordReset", {
          action: "create",
          title: "Reset User Password",
          formData: {
            user: user,
            pageNumber: pageNumber,
            selectedType: this.selectedType,
          },
          component: ResetPasswordForm,
        });
      },
      updateUser(user) {
        let product= [];
        let user_id = user.id;
        let first_name = user.first_name;
        let last_name = user.last_name;
        let user_name = user.user_name;
        let email =user.email;
        let role_id = user.role_id;
        let sel_teams=[];
        let selected_team = [];
        let team = user.user_team;
        let teams = this.teams;
        if(team && team.length > 0){
          selected_team = team.map(({ team_id }) => team_id);         
          teams.forEach((key) => {
            if(selected_team.includes(parseInt(key.id))){
              sel_teams.push({"id":key.id,"name":key.name});
            }   
          });
          console.log(selected_team,sel_teams);
        }
        if(this.products)
        {
          this.products.forEach(key => {
          if(user_id == key['user_id']){
            product.push(key.product);
          }
        });
        }
       
        let pageNumber = this.page;
        this.$store.dispatch("modal/updateUser", {
          action: "create",
          title: "Update User",
          formData: {
            user_id: user_id,
            first_name: first_name,
            last_name: last_name,
            user_name: user_name,
            email: email,
            role_id: role_id,
            pageNumber: pageNumber,
            selectedType: this.selectedType.id,
            search: this.search,
            product: product,
            client_id:user.client_id,
            client_secret: user.client_secret,
            account_id: user.account_id,
            team: sel_teams,
            teamsList: this.teams,
            filter_team_id: this.filter_team_id,
          },
          component: updateForm,
        });
      },
      usersBySearch() {
        this.selectedType='';
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.isLoader = true;
            this.$store
              .dispatch("users/getadminusersBySearch", [this.search, ""])
              .then(() => {
                this.isLoader = false ;
              });
            this.awaitingSearch = false;
          }, 200);
        }
        this.awaitingSearch = true;
      },
      changeType(event) {
        this.isLoader = true ;
        this.search = '';
        let type = this.selectedType.id;
        this.$store
          .dispatch("users/getadminusersBySearch", ["", type])
          .then(() => {

            this.isLoader = false ;
          });
      },
      changeTeams(event) {
        this.isLoader = true ;
        this.search = '';
        this.type='';

        let team_id = this.department ? this.department.id : "";
        this.filter_team_id = this.department ? this.department.id : "";
        this.$store
          .dispatch("users/getadminusersBySearch", ["","", team_id])
          .then(() => {

            this.isLoader = false ;
          });
      },
     
      getExcelOrgUsers() {
        axios
          .get("/admin/users?limit=" + 0 + "&role_id=" + this.selectedType)
          .then((response) => {
            let res = response.data;
            this.excelDownloadData = res.data;
          });
      },
    },
  };
</script>
<style lang="scss">
  .dropdown-toggle::before,
  .dropdown-toggle::after {
    border: none;
    content: none;
  }

  .dropdown-toggle:hover {
    background-color: #2662ab;
    color: white;
  }

  .dropdown-toggle {
    border-radius: 50%;
  }

  .dropdown-item {
    cursor: pointer;
  }

  .dropdown {
    position: relative;
    display: inline-block;
  }

  .table tbody tr:hover td,
  .table-hover tbody tr:hover th {
    background-color: #f4f8fa;
  }

  .table {
    /* font-size: 0.9rem; */
    font-size: 14px;
    font-weight: 400;
    /* position: relative; */
  }

  .table td {
    vertical-align: middle;
  }

  .cheat {
    text-align: center;
  }
  label.type-label{
    color: #48a6a6; 
    font-weight: 600; 
    font-size: 14px;
  }
  .excel-download:hover,.add-more:hover{
    background: #48a6a6;
    .fa-file-excel-o,  .fa-plus{
      color: white !important;
    } 
  }
  // .add-more:hover{
  //   background: white !important;
  //   >.fa-plus{
  //     color: #48a6a6;
  //   } 
  // }
  // .btn:hover>.fa-file-excel-o,.btn:hover>.fa-plus{
  
  // }
  // @media only screen and (max-width: 1264px) {
    .admin-users-filters {
        max-width: 100% !important;
    }
  // }
    
</style>
<style scoped>
.has-search .form-control {
    height: calc(1.4em + 0.75rem + 2px) !important;
}
</style>